import { isPresent } from './commonUtils';
import { processDomesticEvents } from './campaignTrackerDomestic';
import { processGlobalEvents } from './campaignTrackerGlobal';
import { processInternationalEvents } from './campaignTrackerInternational';

const initialize = () => {
  // TODO: Get these from page, request, locale
  if (isPresent(window.scriptConfig) && isPresent(window.scriptConfig['global-campaign-sdk'])) {
    console.log('script config present');
    const { sourcePage } = window.scriptConfig['global-campaign-sdk'];
    const { market } = window.scriptConfig['global-campaign-sdk'];
    if (sourcePage === 'OneAmex') {
      processGlobalEvents();
    } else if (market === 'US') {
      processDomesticEvents();
    } else {
      processInternationalEvents();
    }
  } else {
    setTimeout(initialize, 1000);
  }
};

export default initialize;
